import type { Recipe } from '@/features/backtest/utils/recipe-types'
import type { CookbookEntry } from './types'

/**
 * A template in the vocabulary the AI builds with (since the 2026-10-06
 * vocabulary swap, which retired recipeWithTradeNodes and its standalone
 * trade nodes): the recipe plus one Trade Manager step, its settings the
 * ones the template sets and its output wired into the socket the template
 * feeds (the Trigger for an entry template, a Price level stop or target, or a
 * Multi Target). The cookbook's own shape, read as a recipe, so the AI's
 * grounding examples build exactly what a template inserts.
 */
export function recipeWithTradeManager(entry: CookbookEntry): Recipe {
  const spec = entry.tradeManager
  if (!spec?.feeds && !spec?.params) return entry.recipe
  const taken = new Set(entry.recipe.map((s) => s.id))
  let id = 'tm'
  for (let n = 2; taken.has(id); n++) id = `tm_${n}`
  return [
    ...entry.recipe,
    {
      id,
      type: 'tradeManager',
      ...(spec.params ? { params: spec.params } : {}),
      ...(spec.feeds ? { inputs: { [spec.feeds.socket]: spec.feeds.from } } : {}),
    },
  ]
}
